<template>
    <van-popup v-model:show="show" @close="close" position="center" :style="{
        minWidth: '80%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '10000'

    }">
        <div class="headImage">
            <img class="image1" src="@/assets/theme/claimActivity_bg.png" alt="">
            <img class="image2" src="@/assets/theme/text_t1.png" alt="">
        </div>
        <div class="popupContainer">
            <!-- <h1 class="gradient-text">{{ $t('bonus.Receive') }}</h1> -->
            <div class="taskListContainer">
                <div class="taskCard" v-for="(item, index) in rewardList" :key="index">
                    <van-row @click="goToPath(item.title)">
                        <van-col span="4" class="activityIcon">
                            <img v-if="item?.icon" :src="item?.icon" alt="">
                            <img v-else src="@/assets/theme/full_wash_chip.png" alt="">
                        </van-col>
                        <van-col span="15" class="circleBtn taskName">
                            {{ $t(`activityName.${item.title}`) }}
                        </van-col>
                        <van-col span="5">
                            <div class="circleBtn">
                                <img src="@/assets/theme/receiveBtn.png" alt="">
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>

        </div>
        <div class="closeICon"><van-icon name="cross" @click="close"
                style="padding: 5px; background-color: #cac8c45e; border-radius: 30px;" /></div>

    </van-popup>
    <CollectPopup ref="collectPopupRef" />
    <CollectTimeDropPopup ref="collectTimeDropPopupRef" />
    <AgentPopup ref="agentRef" />
    <PwaAntiBlockingPopup ref="pwaPopupRef" />
    <PwaStatusPopup ref="pwaPopupStatusRef" />
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, computed, defineExpose, defineEmits, onMounted } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { getTodayRewards } from '@/api/common'
import { useUserStore } from '@/stores/user'
import CollectPopup from '@/view/collect/collectPopup.vue'
import CollectTimeDropPopup from '@/view/collect/collectTimeDropPopup.vue'
import AgentPopup from '@/view/agent/agentPopup.vue'
import PwaAntiBlockingPopup from '../common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../common/pwaStatusPopup.vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { handleMenuClick } from '@/view/components/supportFunction'
const userStore = useUserStore()
const router = useRouter()
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const rewardList = computed<any[]>(() => userStore.claimActivityList)

const agentRef = ref()
const collectPopupRef = ref()
const collectTimeDropPopupRef = ref()
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const emits = defineEmits(['handleShowTreasurePopup'])
const open = () => {
    show.value = true
}
const close = () => {
    userStore.setIsClaimActivityList([])
    show.value = false
    userStore.setIsOpenClaimPopup(false)
}

const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup', path)
    show.value = false
    localStorage.setItem('redirectFromCalim', 'true')
}
const goToPath = (name: any) => {
    
    handleMenuClick(name, router, agentRef, collectPopupRef, collectTimeDropPopupRef,
        pwaPopupRef, pwaPopupStatusRef, show, canRecievedRewards.value, isOpen.value, t, handleShowTreasurePopup
        
    )
}

onMounted(() => {
    setTimeout(() => {
        show.value = true
        userStore.setIsOpenClaimPopup(true)
    }, 1000)
})

defineExpose({ open, close })
</script>

<style scoped>
.popupContainer {
    background-image: linear-gradient(180deg, #f2cca5 0%, #fe983b 100%);
    border-radius: 25px;
    width: 80%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 15% 5% 5%;
    position: relative;
}

.van-overlay {
    z-index: 9999 !important;
    backdrop-filter: blur(.26667rem);
}

.headImage {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-bottom: -15%;
}

.headImage img {
    width: 80%;
    z-index: 1;
}

.gradient-text {
    font-size: 35px;
    background: linear-gradient(180deg, #fcc623, #ff6b01);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    padding: 15px;
    text-align: center;
    margin: 0;
}

.taskListContainer {
    max-height: 40vh;
    width: 100%;
    overflow: hidden;
    overflow-y: scroll;
    scrollbar-width: none;
}

.taskListContainer::-webkit-scrollbar {
    display: none;
}

.taskCard {
    border-radius: 100px;
    background: linear-gradient(180deg, #f8c38e, #ffa423);
    margin: 15px 0;
    border: 3px solid #fff;
}

.activityIcon {
    display: flex;
    align-items: center;
    justify-content: center;
}

.activityIcon img {
    width: 50%;
}

.taskName {
    font-size: 15px;
}

.closeICon {
    padding: 5%;
    text-align: center;
    font-size: 25px;
    color: #ffffffc7;
}

.circleBtn {
    display: flex;
    align-items: center;
}

.circleBtn img {
    width: 100%;
}
</style>